export const about = {
  pageTitle: 'À Propos de',
  pageSubtitle: 'Plus de 15 ans d\'expérience au service de vos projets de rénovation et de construction à Bruxelles. Une entreprise belge qui place la qualité et la satisfaction client au cœur de ses priorités',
  
  // Story Section
  storyTitle: 'Notre Histoire',
  storyP1: 'Fondée par <strong>Al Mohammad Abdul</strong>, Ktran est née d\'une passion pour le bâtiment et d\'un engagement envers l\'excellence. Avec plus de 15 ans d\'expérience dans le secteur de la rénovation, nous avons développé une expertise reconnue à Bruxelles et ses environs',
  storyP2: 'Notre approche repose sur trois piliers fondamentaux : l\'écoute attentive de nos clients, la qualité supérieure de nos réalisations, et le respect strict des délais et budgets convenus',
  storyP3: 'Chaque projet est unique et mérite une attention particulière. C\'est pourquoi nous prenons le temps d\'analyser vos besoins, de vous conseiller sur les meilleures solutions, et de vous accompagner de A à Z dans votre projet de rénovation',
  storyP4: 'Basée à Molenbeek-Saint-Jean, notre entreprise belge est fière de contribuer à l\'amélioration du patrimoine immobilier bruxellois, un projet à la fois',
  storyYears: 'Ans d\'expérience',
  
  // Values Section
  valuesTitle: 'Nos Valeurs',
  valuesSubtitle: 'Des principes qui guident chacune de nos interventions et garantissent votre satisfaction',
  
  qualityTitle: 'Qualité du Travail',
  qualityDesc: 'Nous utilisons des matériaux de qualité supérieure et appliquons les meilleures techniques pour garantir des résultats durables et esthétiques',
  
  timeTitle: 'Respect des Délais',
  timeDesc: 'Chaque projet est planifié avec précision. Nous nous engageons à respecter les délais convenus pour votre tranquillité d\'esprit',
  
  cleanTitle: 'Chantier Propre',
  cleanDesc: 'Nous maintenons un chantier organisé et propre tout au long des travaux, avec un nettoyage complet à la fin de chaque journée',
  
  communicationTitle: 'Communication Transparente',
  communicationDesc: 'Nous vous tenons informé à chaque étape du projet. Nous restons disponibles pour répondre à vos questions et ajuster selon vos besoins',
  
  // Timeline
  timelineTitle: 'Notre Parcours',
  timelineSubtitle: 'Une croissance continue basée sur la confiance et la qualité',
  
  timeline2008Title: 'Début de l\'Aventure',
  timeline2008Desc: 'Al Mohammad Abdul lance son activité de construction et rénovation à Bruxelles',
  
  timeline2015Title: 'Expansion des Services',
  timeline2015Desc: 'Élargissement de l\'équipe et diversification des services pour répondre à tous les besoins en rénovation',
  
  timeline2020Title: 'Certification Qualité',
  timeline2020Desc: 'Obtention de certifications professionnelles et renforcement de notre engagement envers l\'excellence',
  
  timeline2024Title: 'Plus de 150 Projets',
  timeline2024Desc: 'Aujourd\'hui, Ktran est reconnue comme un acteur de confiance dans la rénovation à Bruxelles et ses environs',
  
  // Service Area
  serviceAreaTitle: 'Zone d\'Intervention',
  serviceAreaText: 'Nous intervenons principalement à <strong>Bruxelles et ses environs</strong>, avec une connaissance approfondie des spécificités locales et des normes belges en vigueur',
  
  areaBrusselsTitle: 'Bruxelles-Capitale',
  areaBrusselsDesc: 'Toutes les communes de Bruxelles',
  
  areaPeripheryTitle: 'Périphérie Bruxelloise',
  areaPeripheryDesc: 'Brabant wallon et flamand',
  
  areaOnDemandTitle: 'Déplacements sur Demande',
  areaOnDemandDesc: 'Contactez-nous pour d\'autres régions',
  
  // Contact Info
  contactInfoTitle: 'Informations de Contact',
  contactCompany: 'Ktran',
  contactVAT: 'N° TVA : BE0729535515',
  contactAddress1: 'Rue de Rotterdam 50',
  contactAddress2: '1080 Molenbeek-Saint-Jean',
  contactAddress3: 'Belgique',
  
  // CTA
  ctaTitle: 'Travaillons Ensemble sur Votre Projet',
  ctaText: 'Contactez-nous pour discuter de votre projet de rénovation. Nous serons ravis de vous rencontrer et de vous proposer une solution adaptée à vos besoins',
  ctaQuote: 'Demander un Devis',
  ctaCall: 'Appelez-nous'
};